import { inject } from '@angular/core';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { forkJoin } from 'rxjs';
import { enableSocketIO } from './app.config';
import { SocketService } from './core/socket/socket.service';
import { UserService } from './core/user/user.service';

export const initialDataResolver = () => {
    const navigationService = inject(NavigationService);
    const userService = inject(UserService);
    const socketService = inject(SocketService);
    // const dataService = inject(DataService);
    if (enableSocketIO) {
        socketService.connect();
    }

    // Fork join multiple API endpoint calls to wait all of them to finish
    return forkJoin([
        navigationService.get(),
        userService.get(),
        // dataService.get(),
    ]);
};
